import React from "react";
import cx from "classnames";
import styles from "./MainContainer.module.scss";

interface MainContainerProps {
  children?: React.ReactNode;
  className?: string;
}

const MainContainer: React.FC<MainContainerProps> = ({
 className = "",
 children = null, // If you want to allow string, keep it as `children = ""`. However, React.ReactNode covers strings, so `null` is a more typical default for children.
}) => {
  return <div className={cx(styles.container, className)}>{children}</div>;
};

export default MainContainer;
